import Phaser from 'phaser';

import { getDevicePixelRatio } from '@/features/letterParty/game/utils/canvasSize';

import type LetterPartyScene from './scenes/LetterPartyScene';

function shouldUseCanvasRenderer(): boolean {
	if (typeof navigator === 'undefined') {
		return false;
	}

	const isIpadWithDesktopUserAgent = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

	return /Android|iPad|iPhone|iPod/i.test(navigator.userAgent) || isIpadWithDesktopUserAgent;
}

export function createGameConfig(parent: HTMLElement, scene: LetterPartyScene): Phaser.Types.Core.GameConfig {
	const devicePixelRatio = getDevicePixelRatio();

	return {
		type: shouldUseCanvasRenderer() ? Phaser.CANVAS : Phaser.AUTO,
		parent,
		width: Math.max(1, Math.round((parent.clientWidth || 1) * devicePixelRatio)),
		height: Math.max(1, Math.round((parent.clientHeight || 1) * devicePixelRatio)),
		transparent: true,
		scene,
		scale: {
			mode: Phaser.Scale.NONE,
		},
		audio: {
			disableWebAudio: false,
		},
		antialias: true,
		roundPixels: true,
	};
}
